<template>
  <div class="content" id="d1">
    <div class="main clearfix">
      <div class="video-list">
        <span @click="toOtherPath('weike')">我的微课</span>
        <span @click="toOtherPath('memoir')">课堂实录</span>
        <!-- <span @click="toOtherPath('Match')">参赛视频</span> -->
        <span class="active" @click="toOtherPath('live')">直播视频</span>
      </div>
      <table v-loading="loading">
        <tr class="first-tr">
          <td class="td1">标题</td>
          <td width="240">权限</td>
          <td class="td2" width="250">直播时间</td>
          <td width="250">状态</td>
          <td v-if="isSelf" width="240">操作</td>
        </tr>
        <div v-if="isShow" class="none">暂无直播视频</div>
        <tr class="second-tr" v-for="item in this.liveList" :key="item.id" v-else>
          <td class="td-1">
            <p @click="toInfo(item)" :title="item.title">{{item.title}}</p>
          </td>
          <td class="td-2 limit" :title="item.permission_scope == 1 ? item.cn_permission_scope: item.org_name + '校内'">
            {{item.permission_scope == 1 ? item.cn_permission_scope: item.org_name + "校内"}}</td>
          <td class="td-2 td-3">{{item.time}}</td>
          <td class="td-2 td-3">{{item.status | getStatus}}</td>
          <td class="td-2" v-if="isSelf">
            <el-dropdown v-if="item.video_resid && item.status == 3">
              <span class="el-dropdown-link">
                下载/更改
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="operation" @click.native="download(item.file_url, item.video_filename)">下载视频
                </el-dropdown-item>
                <el-dropdown-item class="operation" v-if="role.owner_school == item.schoolid"
                  @click.native="dialogVisible1 = true, operVideo(item, 2)">更改视频</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span v-if="item.video_resid == false && item.status == 3"
              :style="item.schoolid == identity.school_id  && identity.identity_status == 1 ? '' : 'color:#ccc'"
              @click="operVideo(item, 1)" class="el-dropdown-link operation">上传视频</span>
            <span class="operation del" @click="delArticleSub(item.id)">删除</span>
          </td>
        </tr>
      </table>

      <!-- 上传/更改视频弹窗 start-->
      <el-dialog :title="type" :visible.sync="dialogVisible1" width="600px" :close-on-click-modal="false">
        <div class="upload-editor clearfix">
          <div class="editor-common-box">
            <span class="text">标题</span>
            <div class="common-wrap">
              <el-input class="long" name="name" type="text" :placeholder="title" maxlength="30" disabled></el-input>
            </div>
          </div>

          <div class="editor-common-box">
            <span class="text">主讲人</span>
            <div class="common-wrap">
              <el-input class="long" id="name" name="name" type="text" :placeholder="username" maxlength="30" disabled>
              </el-input>
            </div>
          </div>
          <div class="editor-common-box">
            <span class="text">播出时间</span>
            <div class="common-wrap">
              <el-input class="long author" id="name" name="name" type="text" :placeholder="start_time" maxlength="10"
                disabled></el-input>

              <span style="padding:10px;">至</span>

              <el-input class="long author" id="name" name="name" type="text" :placeholder="end_time" maxlength="10"
                disabled></el-input>
            </div>
          </div>

          <div class="editor-bottom editor-common-box">
            <span class="text">权限</span>
            <div class="common-wrap">
              <el-input class="long" id="name" name="name" type="text" :placeholder="cn_permission_scope" maxlength="30"
                disabled></el-input>
            </div>
          </div>
          <div class="editor-common-box">
            <span class="text">上传视频</span>
            <span class="tips">支持MP4格式，不大于1G</span>
            <div class="common-wrap">
              <uploader ref="upload" class="uploader-example" :options="options" :autoStart="false"
                :file-status-text="statusText" @file-success="onSuccess" @file-added="filesAdded"
                @file-progress="fileProgress" @file-error="onFileError" @file-removed="onRemove">
                <uploader-unsupport></uploader-unsupport>
                <uploader-drop>
                  <uploader-btn :single="true" :attrs="attrs2">点击上传</uploader-btn>
                </uploader-drop>
                <uploader-list v-show="panelShow"></uploader-list>
              </uploader>
              <ul class="el-upload-list el-upload-list--text" v-show="show_filename">
                <li tabindex="0" class="el-upload-list__item is-success">
                  <a class="el-upload-list__item-name">
                    <i class="el-icon-video-play"></i>
                    {{file_name}}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="editor-common-box">
            <span slot="footer" class="dialog-footer">
              <el-button size="medium" type="primary" :disabled="isDisabled" @click="submitOk">确定</el-button>
              <el-button size="medium" type="info" @click="clearData">取消</el-button>
            </span>
          </div>
        </div>
      </el-dialog>
      <!-- 上传视频弹窗 end-->

      <!-- 分页 -->
      <el-pagination background layout="prev, pager, next" @current-change="PageChange" :current-page="this.page"
        :page-size="this.pageSize" :total="this.count" :hide-on-single-page="true"></el-pagination>
      <!-- 分页 -->

      <!-- 删除直播-->
      <el-dialog title="提示" :visible.sync="dialogVisible3" width="300px" center style="margin-top:20vh">
        <span>确认删除该直播？</span>
        <br />
        <br />
        <span class="del-span">直播删除后将无法找回！</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="delArticleOk()">确定</el-button>
          <el-button @click="dialogVisible3 = false">取消</el-button>
        </span>
      </el-dialog>
      <!-- 删除直播-->
    </div>
  </div>
</template>

<script>
import globalApi from "@/common/globalApi.js";
import { log } from "util";
import SparkMD5 from "spark-md5";
export default {
  name: "MyClass",
  data() {
    return {
      show_filename: true, // 编辑视频-是否显示文件名
      uploadUrl: "", // 文件上传地址
      uploadData: "", // 文件上传参数
      fileList: [],
      file_name: "",
      type: "",
      maxSize: 1, // 视频文件限制大小(单位:G)
      extensions: ["mp4"], // 视频文件允许上传的格式
      fileLimit: 1, // 限制个数
      isDisabled: false, // 是否禁止点击上传按钮
      isShow: false, // 是否显示缺省页
      dialogVisible1: false, // 上传弹窗
      dialogVisible2: false, // 编辑弹窗
      dialogVisible3: false, // 删除弹窗
      id: "", // 直播id
      page: 1,
      pageSize: 10,
      count: 0,
      role: "", // 获取权限
      identity: "", // 获取身份
      title: "", // 标题
      start_time: "", // 开始时间
      end_time: "", // 结束时间
      cn_permission_scope: "", // 权限
      username: "", // 用户名
      liveList: [], // 直播列表
      isSelf: false, // 是否为自己
      // 分片参数
      // 视频
      FileLimit2: {
        FileMaxSize: 1, // 允许上传的大小 单位(G)
        FileFormat: ["mp4"], // 允许上传的格式
        FileUnit: "G", // 单位
      },
      options: {},
      statusText: {
        success: "上传成功！",
        error: "出错了！",
        uploading: "上传中...",
        paused: "等待中...",
        waiting: "等待中...",
      },
      panelShow: true, // 展示上传panel
      attrs2: {
        accept: ".mp4",
      },
      userid: 1,
      websiteSessionInfo: globalApi.gWebsiteSessionInfo,
      loading: false,
    };
  },
  filters: {
    getStatus: function (value) {
      var status = ["尚未开始", "正在直播", "直播历史", "已被停止"];
      return status[value - 1];
    },
  },
  computed: {
    globalVaranthasInited() {
      return globalApi.gWebsiteSessionInfo.hasInited;
    },
  },
  watch: {
    globalVaranthasInited: function () {
      this.init();
    },
  },
  created() {},

  methods: {
    init() {
      this.owner_id = this.$route.query.userid; // 教师空间id
      this.getLoginUserInfo(); // 获取登录信息
    },
    // 获取用的登录数据并存入localStorage
    async getLoginUserInfo() {
      const isLogin = this.websiteSessionInfo.logined;
      if (isLogin) {
        this.username = this.websiteSessionInfo.userName;
        this.userface = this.websiteSessionInfo.userFace;
        this.userid = this.websiteSessionInfo.userid;
        this.isSelf = this.userid == this.owner_id;
        this.uploadUrl = globalApi.GetWebHost("upload"); // 文件上传地址
        this.uploadData = {
          UserId: this.userid,
          SessionKey: this.websiteSessionInfo.sessionKey,
          OS: 4,
          CheckCode: globalApi.randomString(40),
        };
        this.options = {
          target: globalApi.GetWebHost("upload"), // 上传地址
          testChunks: false,
          singleFile: true, // 启用单个文件上传。上传一个文件后，第二个文件将超过现有文件，第一个文件将被取消。
          chunkSize: "1048576" * 1, //分块大小 单位(M)
          query: {
            //传参
            UserId: this.userid,
            SessionKey: this.websiteSessionInfo.sessionKey,
            OS: 4,
            PluginType: 1,
          },
        };
      }
      this.GetAuth(); // 获取权限
      this.GetIdentity(); // 获取身份
      this.SearchWebCast(); // 获取直播列表
    },

    // 分页导航
    PageChange(val) {
      this.page = val;
      document.documentElement.scrollTop = 0;
      this.SearchWebCast(); // 获取直播列表
    },

    // 获取权限
    async GetAuth() {
      const data = {
        s: "Common.Auth.getAuth",
        operator_id: this.userid, // 登陆者id
        user_id: this.owner_id, // 空间id
      };

      const res = await globalApi.post(data);
      if (res.data.ret != 200) {
        return false;
      }
      this.role = res.data.data;
    },

    // 获取身份
    async GetIdentity() {
      const data = {
        s: "Common.Auth.getIdentity",
        user_id: this.userid, // 登陆者id
      };

      const res = await globalApi.post(data);
      if (res.data.ret != 200) {
        return false;
      }
      this.identity = res.data.data;
    },

    // 详情页跳转
    async toInfo(val) {
      var permission_scope = val.permission_scope; // 权限 1公开 4 本校 8 本校老师
      //非公开权限
      if (permission_scope != 1) {
        const is_login = await globalApi.CheckLoginUserStatus(this);
        if (!is_login) {
          this.$message.error("对不起,你没有该权限!");
          return;
        }
      }
      var status = val.status; // 直播状态 1未开始 2直播中 3已结束
      if (!globalApi.IsLogIned() && permission_scope != 1) {
        window.open(globalApi.GetWebHost("school") + "login", "_self"); // 没有登录跳转到登录页面(公开可不登录)
        return false;
      }
      if (
        permission_scope == 1 ||
        (permission_scope == 4 && this.identity.school_id == val.schoolid) ||
        (permission_scope == 8 && this.role.isSchoolTeacher == true) ||
        this.isSelf
      ) {
        if (status == 2) {
          globalApi.jumpPath(2, "school_webcast_live_info", "id=" + val.id); // 跳转直播页面
        } else {
          globalApi.jumpPath(2, "school_webcast_class_info", "id=" + val.id); // 跳转视频播放页面
        }
      } else {
        this.$message.error("对不起,你没有该权限!");
        return false;
      }
    },

    // 获取直播列表
    async SearchWebCast() {
      this.loading = true;
      var data = {
        s: "WebTeacherSpace.MyVideo.SearchWebCast",
        teacher_id: this.owner_id, // 教师空间id
        page: this.page,
        page_size: this.pageSize,
        only_not_stop: this.isSelf ? false : true,
      };

      const res = await globalApi.post(data);
      this.loading = false;
      const response = res.data.data.result;
      if (res.data.ret != 200 || response != 1) {
        return false;
      }

      this.count = res.data.data.recordcount;
      this.liveList = res.data.data.list;
      this.count == 0 ? (this.isShow = true) : (this.isShow = false);
    },

    // 删除直播
    async DeleteWebCast() {
      var data = {
        s: "WebTeacherSpace.MyVideo.DeleteWebCast",
        teacher_id: this.owner_id, // 教师空间id
        id: this.id,
      };

      const res = await globalApi.post(data);
      const response = res.data.data.result;
      if (res.data.ret != 200 || response != 1) {
        return false;
      }
      if (response) {
        this.dialogVisible3 = false;
        this.$message.success("删除成功!");
        this.SearchWebCast(); // 获取直播列表
      } else {
        this.$message.error(response.data.msg);
      }
    },

    // 上传视频接口
    async PublishWebCastFile() {
      var data = {
        s: "WebTeacherSpace.MyVideo.PublishWebCastFile",
        teacher_id: this.owner_id, // 教师空间id
        id: this.id, // 直播id
        file: this.file, // 视频路径地址
        file_name: this.file_name, // 视频文件原始名字
      };

      const res = await globalApi.post(data);
      const response = res.data.data.result;
      if (res.data.ret != 200 || response != 1) {
        return false;
      }

      if (response == 1) {
        this.$message.success(this.type + "成功!");
        this.dialogVisible1 = false;
        this.SearchWebCast();
      } else {
        this.$message.error(res.data.msg);
      }
    },

    // 点击上传/编辑视频
    // type=1 上传视频
    // type=2 更改视频
    async operVideo(val, type) {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      if (this.identity.school_id == val.schoolid) {
        this.dialogVisible1 = true;
      } else {
        return false;
      }
      this.panelShow = false;
      this.type = type == 1 ? "上传视频" : "更改视频";
      this.show_filename = type == 1 ? false : true;
      this.id = val.id; // 直播id
      this.title = val.title; // 标题
      this.start_time = val.start_time; // 开始时间
      this.end_time = val.end_time; // 结束时间
      this.cn_permission_scope = val.cn_permission_scope; // 权限
      this.username = val.speakername; // 用户名
      this.file = val.video_resid;
      this.file_name = val.video_filename;
      if (val.video_resid) {
        this.fileList = [{ name: val.video_filename, url: val.video_resid }];
      }
    },

    //上传视频确定
    submitOk() {
      if (this.file == undefined || this.file == false) {
        this.$message.error("请上传视频!");
        return false;
      } else {
        this.PublishWebCastFile(); // 上传视频接口
      }
    },

    //点击取消上传
    clearData() {
      this.clear(); // 清除数据
      this.isDisabled = false; // 允许点击
      this.dialogVisible1 = false;
      this.dialogVisible2 = false;
    },

    // 删除按钮
    async delArticleSub(id) {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      this.dialogVisible3 = true;
      this.id = id; // 文章id
    },

    // 删除文章确定
    delArticleOk() {
      this.DeleteWebCast(); // 删除直播
    },

    // 下载文件
    download(file_url, file_name) {
      window.location =
        globalApi.GetWebHost("private-api") +
        "/?s=WebTeacherSpace.TeachingArticle.download" +
        "&file_url=" +
        file_url +
        "&file_name=" +
        file_name;
    },

    // 跳转到别的页面
    toOtherPath(name) {
      this.$router.push({ path: name, query: { userid: this.owner_id } });
    },

    // 清除数据
    clear() {
      this.fileList = [];
      if (this.$refs.upload != undefined) {
        if (this.$refs.upload.files[0]) {
          this.$refs.upload.files[0].cancel();
        }
      }
    },

    // @分片相关--------

    // 检查文件格式
    // fileName 文件名称
    // extensions 允许上传的格式
    checkExtensions(fileName, extensions) {
      var format = fileName.split(".").pop().toLowerCase(); // 用户上传的文件格式

      // 把允许上传文件格式的数组转为字符串
      var s = extensions.join(",");
      var exp = new RegExp(format);
      if (!exp.test(extensions)) {
        this.$message.warning("请上传 " + s + " 的格式!");
        return false;
      }
      return true;
    },

    // 检查文件大小
    checkSize(fileSize) {
      var FileLimit = this.FileLimit2;
      var isSize = fileSize / 1024 / 1024 / 1024 < this.FileLimit2.FileMaxSize; // 单位(G)
      if (!isSize) {
        this.$message.warning(
          " 文件大小不能大于" + FileLimit.FileMaxSize + FileLimit.FileUnit + "!"
        );
        return false;
      }
      return true;
    },

    // 添加一个文件时触发
    async filesAdded(file) {
      let that = this;
      //检验视频编码格式
      MediaInfo({ format: "object" }, (mediainfo) => {
        globalApi.onChangeFile(mediainfo, file, that);
      });
      console.log(file);
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      var FileLimit = this.FileLimit2;
      const isFormat = this.checkExtensions(file.name, FileLimit.FileFormat); // 文件格式判断
      if (!isFormat) {
        file.ignored = true; // 过滤文件
        file.cancel(); // 停止上传
        return false;
      }

      // 文件大小判断
      const isSize = this.checkSize(file.size);
      if (!isSize) {
        file.ignored = true; // 过滤文件
        file.cancel(); // 停止上传
        return false;
      } else {
        this.panelShow = true; // 展示上传panel
        this.show_filename = false; // 不显示文件名
        this.computeMD5(file); // md5验证
      }
    },

    // 文件上传中触发
    fileProgress(rootFile, file, chunk) {
      // 判断上传是否在上传
      if (file.isUploading()) {
        this.show_filename = false; // 不显示文件名
        this.isDisabled = true; // 禁止点击上传
      }
    },

    // 上传成功后触发
    onSuccess: function (rootFile, file, response, chunk) {
      var response = JSON.parse(response);
      if (response.Result) {
        this.isDisabled = false; // 允许点击上传
        this.file = response.Data.Original; // 视频路径
        this.file_name = response.Data.Realname; // 视频路径
      } else {
        if (response.ErrCode != 4) {
          this.$message.error(response.Errstr);
        }
      }
    },

    // 文件列表移除文件时的钩子(文件)
    onRemove(file, fileList) {
      this.isDisabled = true; // 不允许点击
    },

    // 上传错误触发
    onFileError(rootFile, file, response, chunk) {
      this.$message({
        message: "上传失败,请重新上传!",
        type: "error",
      });
    },

    // 校验MD5
    computeMD5(file) {
      let fileReader = new FileReader();
      let time = new Date().getTime();
      let blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice;
      let currentChunk = 0;
      const chunkSize = 10 * 1024 * 1000;
      let chunks = Math.ceil(file.size / chunkSize);
      let spark = new SparkMD5.ArrayBuffer();
      file.pause();

      loadNext();

      fileReader.onload = (e) => {
        spark.append(e.target.result);
        if (currentChunk < chunks) {
          currentChunk++;
          loadNext();
          this.$nextTick(() => {});
        } else {
          let md5 = spark.end();
          this.computeMD5Success(md5, file);
        }
      };
      fileReader.onerror = function () {
        this.error(`文件${file.name}读取出错，请检查该文件`);
        file.cancel();
      };

      function loadNext() {
        let start = currentChunk * chunkSize;
        let end =
          start + chunkSize >= file.size ? file.size : start + chunkSize;
        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
      }
    },

    // 验证成功
    computeMD5Success(md5, file) {
      file.uniqueIdentifier = globalApi.randomString(32); //把md5值作为文件的识别码
      file.resume(); //开始上传
    },
  },
};
</script>
<style>
</style>

<style lang="scss" scoped>
.clearfix {
  clear: both;
  overflow: hidden;
  zoom: 1;
}
// .content {
//   min-height: 950px;
// }
.el-pagination {
  text-align: center;
  padding: 20px 0;
}
.main {
  width: 1180px;
  border-radius: 4px;
  margin: auto;
  padding-top: 20px;
  min-height: 700px;
}
.video-list {
  width: 1200px;
  height: 40px;
  line-height: 40px;
  box-shadow: 0px 1px 0px 0px rgba(233, 233, 233, 1);
  margin-bottom: 20px;
  span {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    margin-right: 30px;
    cursor: pointer;
  }
  .active {
    color: #0088ff;
  }
}
table {
  width: 1180px;
  text-align: center;
  tr {
    border-bottom: 1px solid rgba(233, 233, 233, 1);
    height: 48px;
    line-height: 48px;
  }
  .first-tr {
    background: #e4e5e8;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);

    .td1 {
      text-align: left;
      padding-left: 50px;
    }
  }
  .second-tr {
    font-family: Microsoft YaHei;
    height: 60px;
    line-height: 60px;
    .limit {
      max-width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    td {
      .status {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
      }
      .status-1 {
        color: rgb(11, 170, 24);
      }
      .status-2 {
        color: rgb(199, 182, 29);
      }
      .status-3 {
        color: rgba(241, 56, 86, 1);
      }
    }
    .td-1 {
      p {
        font-size: 14px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        text-align: left;
        padding-left: 50px;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 20rem;
      }
    }
    .td-2-2 {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 10rem;
    }
    .td-2 {
      font-size: 14px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
    }
    .td-3 {
      span {
        margin: 0 20px;
        cursor: pointer;
      }
    }
  }
}
.el-icon--right {
  margin: 0;
}
</style>
<style lang="scss">
.el-dropdown {
  cursor: pointer;
  margin-left: 20px;
}
.el-popper {
  margin-top: -10px !important;
}
.operation {
  margin: 0 10px 0 10px;
  cursor: pointer;
}
</style>
<style lang="scss">
/* @import "../../assets/css/body.css"; */
.group-video .group-video-content .group-video-list {
  min-height: 20px;
}
.checkbox {
  padding: 10px 0;
  float: right;
}
.editor-common-box {
  margin-bottom: 20px;
  .el-input {
    margin: 15px 0 10px 0;
    width: 475px;
  }
  .tips {
    margin-left: 16px;
    font-size: 12px;
    color: #99a8b4;
  }
}
.editor-common-box:first-child {
  margin-top: 0;
}
.upload-demo {
  margin-top: 10px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.el-dialog {
  margin-top: 1vh !important;
}
.el-dialog__body {
  padding-top: 10px;
}

.el-dialog__header {
  padding: 20px 20px 10px;
  text-align: center;
}
.el-dialog--center .el-dialog__body {
  text-align: initial;
  padding: 25px 25px 30px;
  text-align: center;
}
.el-dialog__wrapper {
  top: 100px;
}
</style>
<style lang="css">
.editor-common-box .author {
  width: 220px;
  height: 34px;
}
.none {
  height: 480px;
  line-height: 620px;
  text-align: center;
  background: url(../../assets/img/home_img_2.png) no-repeat center 100px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  position: absolute;
  width: 1180px;
}
</style>
<style>
.uploader-example {
  width: 450px;
  padding: 15px;
  margin-top: 20px;
  font-size: 12px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
}

.uploader-example .uploader-btn {
  margin-right: 4px;
}

.uploader-example .uploader-list {
  max-height: 440px;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: auto;
}
.uploader-file-actions .uploader-file-pause {
  display: none !important;
}
.uploader-file-actions .uploader-file-resume {
  display: none !important;
}
.uploader-file-actions .uploader-file-retry {
  display: none !important;
}
.uploader-file-info .uploader-file-name .uploader-file-icon {
  display: none !important;
}
.uploader-file-status span i {
  display: none !important;
}
</style>